import {Base64} from 'js-base64';
import * as qs from "qs";

export default class SearchUrlUtil {

  static MULTI_SEPARATOR = ",";
  static SEPARATOR = " ";

  static buildQueryString({sorted, page, pageSize, filtered, keyword}) {

    let qsParamList = [];

    if (sorted && sorted.length > 0) {
      let paramList = [];

      for (let i = 0; i < sorted.length; i++) {
        const currentSort = sorted[i];
        paramList.push(encodeURIComponent(currentSort.id) + SearchUrlUtil.SEPARATOR + (currentSort.desc ? 'DESC' : 'ASC'));
      }

      qsParamList.push(`sorted=${paramList.join(SearchUrlUtil.MULTI_SEPARATOR)}`);
    }

    if (typeof page !== 'undefined') {
      qsParamList.push(`page=${page}`);
    }

    if (typeof keyword !== 'undefined') {
      let encodedKeyword = encodeURIComponent(keyword)
      qsParamList.push(`keyword=${encodedKeyword}`);
    }

    if (typeof pageSize !== 'undefined') {
      qsParamList.push(`pageSize=${pageSize}`);
    }

    if (filtered && filtered.length > 0) {
      let paramList = [];

      for (let i = 0; i < filtered.length; i++) {
        const currentFilter = filtered[i];
        paramList.push(encodeURIComponent(currentFilter.id) + SearchUrlUtil.SEPARATOR + Base64.encode(currentFilter.value));
      }

      qsParamList.push(`filtered=${paramList.join(this.MULTI_SEPARATOR)}`);
    }

    return "?" + qsParamList.join("&");

  }


  static extractSearch(queryString) {
    const numberProps = ['pageSize', 'page'];

    let urlState = {};
    const qsParams = qs.parse(queryString, {ignoreQueryPrefix: true});

    let sorted = qsParams['sorted'];
    if (sorted) {
      let sorts = sorted.split(SearchUrlUtil.MULTI_SEPARATOR);
      let sortState = [];

      for (let i = 0; i < sorts.length; i++) {
        let splitArr = sorts[i].split(SearchUrlUtil.SEPARATOR);
        if (splitArr.length === 2) {
          sortState.push({'id': splitArr[0], 'desc': splitArr[1] = 'DESC'})
        }
      }

      if (sortState.length > 0) {
        urlState.sorted = sortState;
      }
      delete qsParams['sorted'];
    }

    let filtered = qsParams['filtered'];
    if (filtered) {
      let filters = filtered.split(SearchUrlUtil.MULTI_SEPARATOR);
      let filterState = [];

      for (let i = 0; i < filters.length; i++) {
        let splitArr = filters[i].split(SearchUrlUtil.SEPARATOR);
        if (splitArr.length === 2) {
          filterState.push({'id': splitArr[0], 'value': Base64.decode(splitArr[1])})
        }
      }

      if (filterState.length > 0) {
        urlState.filtered = filterState;
      }
      delete qsParams['filtered'];
    }

    for (let i = 0; i < numberProps.length; i++) {
      const prop = numberProps[i];

      let numberProp = qsParams[prop];
      if (numberProp) {
        let numberVal = SearchUrlUtil.convertToNumber(numberProp);

        if (numberVal != null) {
          urlState[prop] = numberVal;
        }
      }
      delete qsParams[prop];
    }

    return {...urlState, ...qsParams};
  }


  static convertToNumber(numberStr) {
    try {
      return +numberStr;
    } catch (e) {
      //ignore
    }
    return null;
  }

}